import React from 'react'

import { Close, ExpandMore, Search } from '@mui/icons-material'
import {
  Accordion as AccordionBase,
  AccordionDetails as AccordionDetailsBase,
  AccordionSummary as AccordionSummaryBase,
  Grid as BaseGrid,
  styled
} from '@mui/material'
import { CheckBox as BaseCheckBox } from '@chilecompra/react-kit/components'

export const Accordion = styled(AccordionBase)``

export const AccordionSummary = styled(AccordionSummaryBase)`
  &.MuiAccordionSummary-root {
    padding: 0;
  }
`

export const AccordionDetails = styled(AccordionDetailsBase)`
  &.MuiAccordionDetails-root {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
`

export const CheckBox = styled(BaseCheckBox)`
  &.MuiFormControlLabel-root .MuiFormControlLabel-label {
    color: ${props => props.theme.palette.gray[50]};
    font-size: 14px;
    margin: 3px 0 0;
  }
`

export const ExpandMoreIcon = styled(ExpandMore)`
  font-size: 22px;
`

export const Grid = styled(({ textAlign, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.textAlign || 'initial'};
  width: 100%;
`

export const SearchIcon = styled(({ color, ...props }) => <Search {...props} />)`
  font-size: 14px;

  &.MuiSvgIcon-root {
    fill: ${({ color, theme }) => (color === 'blue' ? theme.palette.blue[50] : theme.palette.gray[100])};
    cursor: pointer;
    margin-right: 8px;
  }
`

export const ClearIcon = styled(Close)`
  font-size: 14px;

  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black3};
    cursor: pointer;
    margin-right: 8px;
  }
`

export const SecondaryFiltersWrapper = styled('div')`
  grid-area: filters;
`

export const Hidden = styled('div')`
  display: none;
`
